/* eslint-disable no-mixed-spaces-and-tabs */
import { IonButton, IonIcon, IonInput, IonItem } from '@ionic/react';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Modal from '../../components/modal';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { deepIsDefined, goBack, validateForm } from '../../lib/utils';
import { checkDiscount, checkDiscountWithTaxes, checkMultiBasketDiscount, checkMultiBasketDiscountWithTaxes, checkVoucherDiscount, sendVoucherCode, setCommonProp, setProfileProp, showToast } from '../../store/actions';
import './index.css';
import { alertCircleOutline, chevronForwardOutline } from 'ionicons/icons';

class ApplyVouchers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			discounts: null,
			selectedVoucher: null,
			showModal: null,
			voucherCode: '',
			disabledAppliedButton: false,
			formErrors: {
				voucherCode: '',
			},
			checkOnlyAppliedVoucher: getConfig().flags.calculateVoucherDiscountOnApply ?? false
		};
		this.formConfig = {
			voucherCode: { type: 'text', required: true },
		};
	}

	componentDidMount() {
		this.props.dispatch(setProfileProp('applicableVouchers', []));
		if (!this.state.checkOnlyAppliedVoucher) {
			const { dispatch } = this.props;
			if (Basket.tax_breakdown.length > 0) {
				if (Basket.has_multi_basket) {
					dispatch(checkMultiBasketDiscountWithTaxes(Basket.parseBasketForMultiBasketCheckVouchers(true)));
				} else {
					dispatch(checkDiscountWithTaxes(Basket.parseBasketForCheckVouchers(true)));
				}
			} else {
				if (Basket.has_multi_basket) {
					dispatch(checkMultiBasketDiscount(Basket.parseBasketForMultiBasketCheckVouchers()));
				} else {
					dispatch(checkDiscount(Basket.parseBasketForCheckVouchers()));
				}
			}

		}
	}
	checkVoucherDiscountAmount = (voucher) => {
		this.setState({ selectedVoucher: voucher }, () => {
			if (Basket.has_multi_basket) {
				this.props.dispatch(checkVoucherDiscount({ ...Basket.parseBasketForMultiBasketCheckVouchers(), selectedVoucher: this.state.selectedVoucher }))
			} else {
				this.props.dispatch(checkVoucherDiscount({ ...Basket.parseBasketForCheckVouchers(), selectedVoucher: this.state.selectedVoucher }))

			}
		})
	}
	setVoucher = (voucher, add = false) => {
		this.setState({ selectedVoucher: voucher }, () => {
			const { vouchers, applicableVouchers } = this.props;
			const { selectedVoucher } = this.state;
			const appliedVoucher = vouchers.find((voucher) => voucher.id === selectedVoucher.id);
			const applicableVoucher = applicableVouchers.find((appliableVoucher) => appliableVoucher.id === selectedVoucher.id);
			if (Basket.canVoucherBeApplied(appliedVoucher, applicableVoucher)) {
				this.setState({ disabledAppliedButton: true }, () => {
					Basket.applyPoints(0);
					if (add) {
						this.addVoucher()

					}
				});
			} else {
				this.setState({ disabledAppliedButton: false });
			}
		});
	};

	addVoucher = () => {
		const { selectedVoucher } = this.state;
		const { vouchers, applicableVouchers, dispatch, __ } = this.props;
		const appliedVoucher = vouchers.find((voucher) => voucher.id === selectedVoucher.id);
		const applicableVoucher = applicableVouchers.find((appliableVoucher) => appliableVoucher.id === selectedVoucher.id);
		if (Basket.canVoucherBeApplied(appliedVoucher, applicableVoucher)) {
			this.setState({ selectedVoucher: null }, () => {
				Basket.addVoucher(appliedVoucher, applicableVoucher);
				goBack();
			});
		} else {
			dispatch(showToast(__('Your basket is higher then voucher cost. Please add more items in basket'), 'warning'));
		}
	};

	showModal = (show) => {
		this.setState({ showModal: show });
		this.clearFields();
	};

	clearFields = () => {
		this.setState({ voucherCode: '' });
	};

	sendCode = () => {
		const { dispatch, __ } = this.props;
		let formErrors = validateForm(this.formConfig, this.state, __);
		this.setState({ formErrors });
		if (Object.keys(formErrors).length === 0) {
			const { voucherCode } = this.state;
			const data = { code: voucherCode.toUpperCase() };
			this.clearFields();
			dispatch(sendVoucherCode(data, true));
			this.showModal(false);
		}
	};

	filterVouchers = (vouchers, appliedVouchers) => {
		const { applicableVouchers, availableBalance } = this.props;
		let filteredVouchers = [];
		if (applicableVouchers && applicableVouchers.length > 0) {
			applicableVouchers.forEach((discount) => {
				let findedVoucher = vouchers.find((voucher) => voucher.id === discount.id);
				if (getConfig().vouchersType === 2) {
					if (findedVoucher && availableBalance > findedVoucher.cost) {
						filteredVouchers.push(findedVoucher);
					}
				} else {
					if (findedVoucher) {
						filteredVouchers.push(findedVoucher);
					}
				}
			});
		}
		if (appliedVouchers && appliedVouchers.length > 0) {
			const ids = appliedVouchers.map((i) => i.id);
			return filteredVouchers.filter((filteredVoucher) => ids.indexOf(filteredVoucher.id) === -1);
		}
		return filteredVouchers;
	};
	filterOtherVouchers(arr1, arr2) {
		const idsToRemove = new Set(arr2.map(item => item.id));
		return arr1.filter(item => !idsToRemove.has(item.id));
	}
	render() {
		const { __, vouchers } = this.props;
		const { selectedVoucher, voucherCode, showModal, disabledAppliedButton, checkOnlyAppliedVoucher } = this.state;
		const appliedVouchers = Basket ? Basket.applied_vouchers : [];
		let filteredVouchers = []
		let otherVouchers = []
		if (!checkOnlyAppliedVoucher) {
			filteredVouchers = this.filterVouchers(vouchers, appliedVouchers);
			otherVouchers = this.filterOtherVouchers(vouchers, filteredVouchers)
		}
		filteredVouchers.sort((a, b) => moment(a.expiry_date) - moment(b.expiry_date))
		otherVouchers.sort((a, b) => moment(a.expiry_date) - moment(b.expiry_date))


		return (
			<>
				<div className="flex-row-wrapper ">
					{checkOnlyAppliedVoucher ? <>
						<StrongText className='block text-to-update'>{__('Your vouchers')}</StrongText>
						<Spacer size={2} />
						<div className='box-wrapper'>
							{vouchers.map((voucher, index) => (
								<IonItem button key={`${voucher.reward.id}_${index}`} lines='none' onClick={() => { this.checkVoucherDiscountAmount(voucher, true); }}>
									<div>
										<StrongText className='block'>{voucher.reward.name}</StrongText>
										<SmallText>{`${__('Expiry date:')} ${moment(voucher.reward.expiry_date, 'YYYY/MM/DD').format('L')}`}</SmallText>
									</div>
									<IonIcon style={{ height: '18px', width: '18px' }} slot='end' icon={chevronForwardOutline} />
								</IonItem>
							))}
						</div>

					</> :
						<>
							<StrongText className='block text-to-update'>{__('Redeemable vouchers')}</StrongText>
							<Spacer size={2} />

							{filteredVouchers.length === 0 ? (
								<>
									<NormalText className='block'>{__("You don't have any applicable vouchers in your wallet")}</NormalText>
								</>
							) : (

								<div className='box-wrapper'>
									{filteredVouchers.map((voucher, index) => (
										<IonItem button key={`${voucher.reward.name}_${index}`} lines='none' onClick={() => { this.setVoucher(voucher, true); }}>
											<div>
												<StrongText className='block'>{voucher.reward.name}</StrongText>
												<SmallText>{`${__('Expiry date:')} ${moment(voucher.expiry_date, 'YYYY/MM/DD').format('L')}`}</SmallText>
											</div>
											<IonIcon style={{ height: '18px', width: '18px' }} slot='end' icon={chevronForwardOutline} />
										</IonItem>
									))}
								</div>
							)}

							<Spacer size={5} />
							{otherVouchers.length > 0 &&
								<>
									<StrongText className='text-to-update'>{__('Other vouchers')}</StrongText>
									<Spacer size={2} />

									<div className='box-wrapper'>
										{otherVouchers.map((voucher, index) => (
											<IonItem button key={`${voucher.reward.name}_${index}`} lines='none'>
												<div>
													<StrongText className='block'>{voucher.reward.name}</StrongText>
													<SmallText>{`${__('Expiry date:')} ${moment(voucher.expiry_date, 'YYYY/MM/DD').format('L')}`}</SmallText>
												</div>
											</IonItem>
										))}
									</div>
								</>
							}

						</>
					}
				</div>

				<Modal className="apply-voucher-modal" isOpen={!!showModal} onDidDismiss={() => this.setState({ showModal: null })} title={__('Enter code')}>
					<div className="flex-row-wrapper">
						<div className="centered flex-row-wrapper">
							<div className=" centered scrollable-y">
								<NormalText>{__('Enter a valid voucher code below to receive your reward')}</NormalText>
								<div className="lefted  voucher-item">
									<IonItem style={{ '--min-height': '32px' }}>
										<IonInput value={voucherCode} onIonChange={(e) => this.setState({ voucherCode: e.target.value })} placeholder={__('Voucher code')} />
									</IonItem>
									<FieldError className="field-error" value={__(this.state.formErrors.voucherCode)} />
								</div>
							</div>
						</div>
						<div className="flex-min">
							<IonButton className='button-uppercase' onClick={() => this.sendCode()} expand="full" color="primary">
								{__('Submit')}
							</IonButton>
						</div>
					</div>
				</Modal>
				<Modal
					className="modal-type-alert"
					isOpen={this.props.voucherErrorModalOpen}
					onDidDismiss={() => this.props.dispatch(setCommonProp('voucherErrorModalOpen', false))}
				>
					<Spacer size={5} />
					<div style={{ display: 'grid', justifyItems: 'center', textAlign: 'center' }}>
						<IonIcon style={{ height: '48px', width: '48px' }} color='primary' icon={alertCircleOutline}></IonIcon>
						<Title className='block'>{__("Voucher not applicable")}</Title>
						<NormalText className='block'>{__('Your order does not qualify for this voucher. Please try another one.')}</NormalText>

					</div>
					<Spacer size={5} />

					<div className='alert-button-group'>
						<IonButton
							color="primary"
							expand="block"
							onClick={() => this.props.dispatch(setCommonProp('voucherErrorModalOpen', false))}
							className="submit-button button-uppercase"
						>
							{__('Continue')}
						</IonButton>

					</div>
				</Modal>
			</>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		availableBalance: deepIsDefined(store, 'profile.profile.available_balance') ? store.profile.profile.available_balance : 0,
		basketUpadated: store.orders.basketUpdated,
		vouchers: store.profile.vouchers || null,
		applicableVouchers: store.profile.applicableVouchers || null,
		voucherErrorModalOpen: store.common.voucherErrorModalOpen
	};
};

export default connect(mapStateToProps)(withTranslation(ApplyVouchers));
